import { ProductQuery, getLocalAttributesRaw, getStringAttributesRaw, mapAttributes } from "@jog/ct"
import { ProductPage } from "@jog/types"

import { getGtmIdFromCT, getPaths, normalizePdpImages, typedBoolean } from "../helper"
import { PrismicBrandsJson, PrismicPdpJson, PrismicPdpSizesJson } from "../scripts"

export const buildProductDetailInfo = (
    {
        product,
        prismic,
        pdpSizesJson,
        brandsJson,
        onlineOnly,
    }: {
        product: ProductQuery["product"]
        prismic: PrismicPdpJson
        pdpSizesJson: PrismicPdpSizesJson
        brandsJson?: PrismicBrandsJson
        onlineOnly: boolean
    },
    locale: string
): ProductPage["productDetailInfo"] => {
    if (!product) throw new Error("Not found product")
    const data = product.masterData.current
    if (!data) throw new Error("Not found product.masterData.current")
    const slug = data.slug || ""
    const category = data.categories.sort((a, b) => +a.orderHint - +b.orderHint)?.at(0)
    const productCategoryPath = getLocalAttributesRaw(category?.custom?.customFieldsRaw || [], "path", locale)
    const attributes = [
        ...(data.masterVariant.attributesRaw || []),
        {
            name: "articlenumber",
            value: slug.split("-").slice(1).join("-").toUpperCase(),
        },
    ]
    const desktopImages = normalizePdpImages(
        data.masterVariant.images,
        prismic.desktopSortingByName || [],
        prismic.sortingByQuality || []
    )
    const mobileImages = normalizePdpImages(
        data.masterVariant.images,
        prismic.mobileSortingByName || [],
        prismic.sortingByQuality || []
    )
    const isFasletShow = prismic.faslet && prismic.categoryKeys.some((item) => item === category?.key)
    const sizeImage = pdpSizesJson?.find((item) => item.key === category?.key) || null
    const ctBrand = (attributes.find((i) => i.name === "brand")?.value as string) || ""
    const brand = brandsJson
        ? (brandsJson as PrismicBrandsJson)?.find((i) => i.brandId === ctBrand.replace(" ", "_").toLowerCase()) || null
        : null
    const gtmId = getGtmIdFromCT(attributes) || ""
    const name = data?.name || ""
    const description = data?.description || ""
    const categories = data.categories.map((val) => val.id) || []
    const color = getLocalAttributesRaw(attributes, "webcolor", locale)
    const material = getLocalAttributesRaw(attributes, "material", locale)
    const size = getStringAttributesRaw(attributes, "size")
    const parent = getStringAttributesRaw(attributes, "parent")
    const mappedAttributes = mapAttributes(attributes, prismic.attributes, locale).filter(typedBoolean)
    const sustainable = prismic.sustainable.filter((slice) => categories.includes(slice.id)).map((i) => i.items) || []
    return {
        ctpId: product?.id || "",
        desktopImages,
        mobileImages,
        isFasletShow,
        sizeImage,
        size,
        brand,
        gtmId,
        name,
        description,
        slug,
        color,
        mappedAttributes,
        material,
        sustainable,
        paths: getPaths(attributes),
        published: product.masterData.published,
        parent,
        productCategoryPath,
        onlineOnly,
    }
}
